"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButtonCustom = exports.StyledSectionContainer = exports.StyledDrawerContainer = exports.StyledContent = exports.StyledTitle = void 0;
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const { toRemString, rem } = ui_common_components_1.utils;
exports.StyledTitle = styled_components_1.default.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  ${({ theme }) => (0, styled_components_1.css) `
    padding: ${rem(theme.Spacing.Size.XSmall)} ${rem(theme.Spacing.Size.XSmall)}
      ${rem(theme.Spacing.Size.XSmall)} ${rem(theme.Spacing.Size.XSmall)};
    border-bottom: ${rem(theme.Border.Size.Small)} solid
      ${theme.Color.Neutrals.Border};
  `}
`;
exports.StyledContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;

  ${({ theme }) => theme.Scrollbar.Panel}
`;
exports.StyledDrawerContainer = styled_components_1.default.div `
  position: fixed;
  flex-direction: column;
  justify-content: flex-end;
  left: 0;
  top: 50%;
  // TODO: Fix this
  transform: translate(28.5%, -50%);
  width: ${rem(280)};
  height: 70%;
  z-index: 2;

  ${({ theme, section, isToolbarVisible }) => (0, styled_components_1.css) `
    display: ${section ? 'flex' : 'none'};
    visibility: ${section ? 'visible' : 'hidden'};
    transition: ${isToolbarVisible
    ? 'none'
    : `all ${theme.Transition.Timing.Out}`};
  `}
`;
exports.StyledSectionContainer = styled_components_1.default.div `
  position: absolute;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  box-shadow: ${toRemString([0, 1, 2, 0])} rgba(0, 0, 0, 0.03),
    ${toRemString([0, 1, 6, 1])} rgba(0, 0, 0, 0.02),
    ${toRemString([0, 2, 4, 0])} rgba(0, 0, 0, 0.02);
  ${({ theme, section, isToolbarVisible }) => (0, styled_components_1.css) `
    background-color: ${theme.Components.Panel.Background};
    border-radius: ${rem(theme.Border.Radius.Large)};
    padding: ${rem(theme.Spacing.Size.XXSmall)};
    transition: ${isToolbarVisible
    ? 'none'
    : `all ${theme.Transition.Timing.Out}`};
    visibility: ${section ? 'visible' : 'hidden'};
  `}
`;
exports.StyledButtonCustom = styled_components_1.default.div `
  display: flex;
  align-items: center;

  button {
    max-width: auto;
    height: ${({ theme }) => ui_common_components_1.utils.rem(theme.Components.PopupMenu.Button.Size)};
  }
`;
//# sourceMappingURL=Section.styles.js.map